import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Dropdown, DropdownToggle, DropdownMenu, Row, Col } from "reactstrap";
import SimpleBar from "simplebar-react";
import { withTranslation } from "react-i18next";
import NotificationsIcon from '@mui/icons-material/Notifications';
import { request } from "../../../utils/request";

const NotificationDropdown = ({ t }) => {
  const [menu, setMenu] = useState(false);
  const [notifications, setNotifications] = useState([]);

  // Toggle function for dropdown menu
  const toggle = () => {
    setMenu((prevState) => !prevState);
  };

  // Fetch notifications from the API
  const fetchNotifications = async () => {
    try {
      const data = await request("/getnotification", { method: "GET" });
      setNotifications(data || []); // Ensure data is always an array
    } catch (error) {
      console.error("Error fetching notifications:", error);
      setNotifications([]);
    }
  };

  useEffect(() => {
    fetchNotifications();
  }, []);

  // Group notifications by serviceName, modelName, and message, then get the latest one based on updatedAt
  const groupAndGetLatestNotifications = (notifications) => {
    const groupedNotifications = {};
    // Group notifications by common fields (serviceName, modelName, message)
    notifications.forEach((notif) => {
      const key = `${notif.serviceName}-${notif.modelName}-${notif.message}`;
      // If not exists or this notification is more recent, update the group
      if (!groupedNotifications[key] || new Date(notif.updatedAt) > new Date(groupedNotifications[key].updatedAt)) {
        groupedNotifications[key] = notif;
      }
    });
    return Object.values(groupedNotifications);
  };

  // Get latest notifications with no duplicates and only those where latestVersion !== currentVersion
  const latestNotifications = groupAndGetLatestNotifications(notifications)
    .filter((notif) => notif.latestVersion !== notif.currentVersion)
    .slice(0, 3);

  return (
    <React.Fragment>
      <Dropdown isOpen={menu} toggle={toggle} className="d-inline-block">
        <DropdownToggle
          tag="button"
          className="btn noti-icon waves-effect"
          id="page-header-notifications-dropdown"
        >
          <NotificationsIcon style={{ color: "white" }} />
          <span className="noti-dot"></span>
        </DropdownToggle>

        <DropdownMenu
          className="dropdown-menu-end dropdown-menu-lg p-0"
          aria-labelledby="page-header-notifications-dropdown"
        >
          <div className="p-3">
            <Row className="align-items-center">
              <Col>
                <h6 className="m-0">{t("Notifications")}</h6>
              </Col>
              {/* <div className="col-auto">
                <Link to="/notifications" className="small">
                  {t("View All")}
                </Link>
              </div> */}
            </Row>
          </div>

          <SimpleBar style={{ maxHeight: "230px" }}>
            {latestNotifications.length > 0 ? (
              latestNotifications.map((notif) => (
                <Link
                  to="#"
                  key={notif._id}
                  className="text-reset notification-item"
                >
                  <div className="d-flex">
                    <div className="avatar-xs me-3">
                      <span className="avatar-title bg-primary rounded-circle font-size-16">
                        <NotificationsIcon />
                      </span>
                    </div>
                    <div className="flex-1">
                      <h6 className="mt-0 mb-1">{notif.message}</h6>
                      <div className="font-size-12 text-muted">
                        <p className="mb-1">
                          {t(`Service: ${notif.serviceName}, Model: ${notif.modelName}`)}
                        </p>
                        <p className="mb-0">
                          <i className="mdi mdi-clock-outline"></i>{" "}
                          {new Date(notif.updatedAt).toLocaleString()}
                        </p>
                      </div>
                    </div>
                  </div>
                </Link>
              ))
            ) : (
              <div className="text-center">{t("No notifications available.")}</div>
            )}
          </SimpleBar>

          <div className="p-2 border-top">
            <Link to="/notifications" className="btn btn-sm btn-link font-size-14 btn-block text-center">
              <i className="mdi mdi-arrow-right-circle me-1"></i>{t(' View All')}
            </Link>
          </div>
        </DropdownMenu>
      </Dropdown>
    </React.Fragment>
  );
};

export default withTranslation()(NotificationDropdown);
